import React from "react";
import styled from "styled-components";
import { LinkContainer, EntityListItem, IfPermitted } from "components/common";
import { Button, Col, DropdownButton, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { ConfigurationWell } from "components/configurationforms";
import Routes from "routing/Routes";
import recentMessagesTimeRange from "util/TimeRangeHelper";
import ForwarderInputStateControl from "./ForwarderInputStateControl";
import ForwarderInputThroughput from "../metrics/ForwarderInputThroughput";
import ForwarderInputMetricContainer from "../metrics/ForwarderInputMetricContainer";
import ForwarderInputStateBadge from "../states/ForwarderInputStateBadge";
const StyledButton = styled(Button)`
  padding-left: 0;
  vertical-align: baseline;
`;
const ForwarderInputListItem = ({
  forwarder = void 0,
  input,
  inputDescription,
  expanded,
  enableEdit,
  onToggleDetails,
  onDeleteInput,
  onEditInput
}) => {
  const _toggleDetail = () => {
    onToggleDetails(input.id);
  };
  const showMetrics = !enableEdit;
  const actions = /* @__PURE__ */ React.createElement(React.Fragment, null, forwarder && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarderinputs:changestate" }, /* @__PURE__ */ React.createElement(ForwarderInputStateControl, { input, forwarder })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "searches:relative" }, /* @__PURE__ */ React.createElement(
    LinkContainer,
    {
      key: `received-messages-${input.id}`,
      to: Routes.search(`gl2_source_input:${input.id}`, recentMessagesTimeRange())
    },
    /* @__PURE__ */ React.createElement(Button, null, "Show received messages")
  )), enableEdit && /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      key: `more-actions-${input.id}`,
      title: "More actions",
      id: `more-actions-dropdown-${input.id}`,
      pullRight: true
    },
    inputDescription && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `forwarderinputs:edit:${input.id}` }, /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: `edit-input-${input.id}`,
        onSelect: () => {
          onEditInput(input);
        }
      },
      "Edit input"
    )),
    /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `forwarderinputs:delete:${input.id}` }, inputDescription && /* @__PURE__ */ React.createElement(MenuItem, { key: `divider-${input.id}`, divider: true }), /* @__PURE__ */ React.createElement(
      DeleteMenuItem,
      {
        key: `delete-input-${input.id}`,
        onSelect: () => {
          onDeleteInput(input);
        }
      },
      "Delete input"
    ))
  ));
  const _getDescription = forwarder ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ForwarderInputMetricContainer, { input, forwarder }), input.configuration && input.configuration.bind_address && /* @__PURE__ */ React.createElement("span", null, "Listening on ", input.configuration.bind_address, ":", input.configuration.port, ".\xA0"), /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", bsSize: "small", onClick: _toggleDetail }, "Show more")) : /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", bsSize: "small", onClick: _toggleDetail }, "Show configuration");
  const additionalContent = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, expanded && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement("h3", null, "Configuration"), /* @__PURE__ */ React.createElement(ConfigurationWell, { id: input.id, configuration: input.configuration, typeDefinition: inputDescription })), showMetrics && /* @__PURE__ */ React.createElement(Col, { md: 5, mdOffset: 2 }, /* @__PURE__ */ React.createElement("h2", null, "Metrics"), forwarder && /* @__PURE__ */ React.createElement(ForwarderInputThroughput, { forwarder, input })))));
  const titleSuffixExtra = forwarder ? /* @__PURE__ */ React.createElement(ForwarderInputStateBadge, { forwarder, input }) : null;
  const titleSuffix = /* @__PURE__ */ React.createElement("span", null, inputDescription ? inputDescription.name : `Unknown input (${input.type})`, "\xA0", titleSuffixExtra);
  return /* @__PURE__ */ React.createElement(
    EntityListItem,
    {
      key: `entry-list-${input.id}`,
      title: input.title,
      titleSuffix,
      description: _getDescription,
      actions,
      contentRow: additionalContent
    }
  );
};
export default ForwarderInputListItem;
